import { render } from "./PODetailPur.vue?vue&type=template&id=37b40ee3"
import script from "./PODetailPur.vue?vue&type=script&lang=js"
export * from "./PODetailPur.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__